import axiosClient from "api/axiosInstance";
import {
  MeteringPointFilters,
  MeteringPoints,
} from "api/models/MeteringPoints";
import { GridRowId } from "@mui/x-data-grid";
import { buildQueryString } from "../../helpers/filters";

export const getMeteringPoints = async (
  page: number,
  size: number,
  filters: { [key: string]: string },
  query?: string,
): Promise<MeteringPoints> => {
  const client = axiosClient();

  const queryParams = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
    ...filters,
  }).toString();

  const queryParam = query ? `&query=${query}` : "";

  const response = await client.get(
    `/metering-points?${queryParams}${queryParam}`,
  );

  return response.data;
};

export const getSingleMeteringPoint = async (
  id: number,
): Promise<MeteringPoints> => {
  const client = axiosClient();

  const response = await client.get(`/metering-points/${id}`);

  return response.data;
};

export const fetchMeteringPointReadings = async (
  data: {
    meteringPointIds: GridRowId[];
  },
  legalConsent?: boolean,
): Promise<MeteringPoints> => {
  const client = axiosClient();

  const response = await client.put(
    `/metering-points/fetch-readings${legalConsent ? "?legalConsent=true" : ""}`,
    data,
  );

  return response.data;
};

export const fetchExportMeteringPoints = async (
  filters: MeteringPointFilters,
): Promise<Blob> => {
  const client = axiosClient();
  const queryString = buildQueryString(filters);

  const response = await client.get(`/metering-points/export?${queryString}`, {
    responseType: "blob",
  });
  return response.data;
};

export const getMeteringPointContracts = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/metering-points/${id}/contracts`);

  return response.data;
};
